<template>
  <div>


    <v-toolbar
      :style="$vuetify.breakpoint.mdAndUp ? 'color:white' : 'color:white'"
      class="subtitle-1 font-weight-bold text-uppercase"
      flat
      color="primary"
      dark
      dense
      v-if="datos.length != 0"
    >
      <v-row>
        <v-col
          class="text-left ml-1 mt-1 subtitle-2 font-weight-bold text-uppercase"
        >
          Marcas 
           <v-badge
               v-if="datos.length != 0"
                color="info"
                :content="datos.length != 0 ? datos.length : null"
                class="font-weight-medium body-2 ml-2"
                
              >
              </v-badge>
         
        </v-col>
        <v-col
          class="text-right ml-1 mt-1 subtitle-2 font-weight-medium text-uppercase"
        >
          <v-tooltip bottom v-if="filter.codmarca.length != 0">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="limpiaMarca()"
                color="white"
                size="30"
              >
                mdi-filter-remove
              </v-icon>
            </template>
            <span>Quitar Filtro Marcas</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-toolbar>

    <v-skeleton-loader
      v-if="datos.length === 0"
      fade-transition
      height="94"
      type="list-item-three-line"
    >
    </v-skeleton-loader>

    <v-list dense v-else>
      <template v-for="(item, j) in datos">
        <v-list-item :key="`${j}-${item.Marca}`">
          <v-list-item-content>
            <v-checkbox
              v-model="checkMarca"
              :label="item.Nombre"
              :value="item.Marca"
              @click="itemmarca(checkMarca)"
              color="accent"
              class="my-n1"
              hide-details
              :disabled="filterconsolidado.length === 0"
              dense
            ></v-checkbox>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="j + 1 < ttMarcasNew.length" :key="j"></v-divider>
      </template>
    </v-list>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  name: "listaMarca",
  data() {
    return {
      checkMarca: []
    };
  },

  watch: {
  
    $route(to, from) {
      this.checkMarca = [];
    },
  },
  props: {
    nitems: Number,
    datos: Array,
    tammarca: Number,
    tamsubcat: Number,
    filterdata: Object,
  },
  methods: {
    ...mapMutations(["GET_BUSCARMARCA", "CLR_BUSCARMARCA"]),
    limpiaMarca() {
      this.checkMarca = [];
      this.CLR_BUSCARMARCA();
    },
    itemmarca(valor) {
      this.GET_BUSCARMARCA(valor);
    },
  },
  computed: {
    ...mapGetters(["filtermarca", "filterconsolidado"]),

    ...mapState([
      "ttArticuloAll",
      "marcaidsel",
      "changeSubcat",
      "filter",
      "ttMarcas",
      "SubCategorias",
    ]),
    marcasItemB: {
      get: function () {//
        let uniqueArray = [];
        let tipoB=0
        this.filter.repuesto==='Maquina' ? tipoB=0 : tipoB=1
if(this.ttMarcas){
  //
  return this.ttMarcas.filter((x) => x.IndTipoPro[tipoB]===true)
}
      
      },
    },
    marcasItem: {
      get: function () {//
        let uniqueArray = [];
        let tipoB=''
        this.filter.repuesto==='Repuesto' ? tipoB='Repuesto' : tipoB='Maquina'

        if (this.ttArticuloAll) {
          uniqueArray = [
            ...new Set(
              this.ttArticuloAll
                .filter((x) => x.SubCategoria === this.filter.codscat && x.TipoProd === tipoB)
                .map((x) => x.Marca)
            ),
          ];
          return uniqueArray.sort((a, b) => a - b);
        }
      },
    },
    ttMarcasNew: {
      get: function () {
        let indice = 0
        if(this.changeSubcat===true){
          this.checkMarca=[];
        }
        if(this.filter.repuesto==='Maquina')
          indice = 0
        if(this.filter.repuesto==='Repuesto')
          indice = 1
        let datos = [],
          xdatos = [];
        if (this.marcasItem) {
           this.marcasItem.forEach((x, index) => {
              datos.push(
              this.ttMarcas.filter((x) => x.Marca === this.marcasItem[index] && x.IndTipoPro[indice]===true)
            );
           })
         
          datos.forEach((x) => {
            xdatos.push(x[0]);
          });
          //filter.codscat.length===0 ? this.ttMarcas : xdatos
          return this.filter.codscat.length===0 ? this.marcasItemB : xdatos;
        }
      },
    },
  },
};
</script>

<style>
</style>